export const X_TC_USERID = Symbol.for('x-tc-userid');
export const AXIOS_CONFIGURATION = Symbol.for('axios-configuration');
export * from './ObjectSerializer';

export interface RequestDetailedFile {
    value: Buffer;
    options?: {
        filename?: string;
        contentType?: string;
    };
}

export type RequestFile = string | Buffer | RequestDetailedFile;
